// extracted by mini-css-extract-plugin
module.exports = {"cards_container":"Cards_cards_container__vGCNh","loading":"Cards_loading__1Ok1p","gif":"Cards_gif__3sSW9"};